import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderMenuItem } from './header-menu';

@Component({
  selector: 'lib-header-mobile-nav',
  imports: [RouterModule, MatIconModule, TranslateModule],
  templateUrl: './header-mobile-nav.component.html',
  styleUrl: './header-mobile-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents' },
})
export class HeaderMobileNavComponent {
  readonly menu = input.required<HeaderMenuItem[]>();
  readonly isOpen = input(false);

  /** Emitted when the user follows a link, so the host can close the menu. */
  readonly navigated = output<void>();

  protected readonly expandedItem = signal<string | null>(null);

  constructor() {
    // Reopening always starts with all submenus collapsed.
    effect(() => {
      if (!this.isOpen()) {
        this.expandedItem.set(null);
      }
    });
  }

  toggleSubmenu(itemTitle: string): void {
    this.expandedItem.update(expanded => (expanded === itemTitle ? null : itemTitle));
  }
}
